import(/* webpackMode: "eager", webpackExports: ["EatsPost"] */ "/app/app/[lang]/blogs/eats/[slug]/EatsPost.tsx");
